import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Li = styled.li`
  cursor: pointer;
  width: 100%;

  &:hover {
    background: ${themeGet('colors.black.10')};
    opacity: 0.5;
  }
`;

export const Link = styled.a`
  color: ${themeGet('colors.black.80')};

  &:hover,
  &:visited {
    color: ${themeGet('colors.black.80')};
  }
`;

export const Option = styled(Li)`
  padding: 16px 20px 16px;
`;

export const SignOut = styled(Li)`
  border-top: 1px solid ${themeGet('colors.black.20')};
  padding: 16px 20px 16px;
`;
